module.exports = __webpack_public_path__ + "img/icon-gen-addsubscriber.2971e824.png";